import React, { createContext, ReactNode, useState } from "react";

export enum Enum_Language {
    FR_FR = "fr-FR",
    EN_US = "en-US",
}

const LanguageContext = createContext<{
    language: Enum_Language;
    updateLanguage: (value: Enum_Language) => void;
}>({
    language: Enum_Language.FR_FR,
    updateLanguage: () => {},
});

type LanguageContextProviderProps = {
    children: ReactNode;
};

const LanguageContextProvider = ({
    children,
}: LanguageContextProviderProps) => {
    const [language, setLanguage] = useState<Enum_Language>(
        Enum_Language.FR_FR,
    );

    const updateLanguage = (value: Enum_Language) => {
        setLanguage(value);
    };

    return (
        <LanguageContext.Provider
            value={{
                language,
                updateLanguage,
            }}
        >
            {children}
        </LanguageContext.Provider>
    );
};

export { LanguageContext, LanguageContextProvider };
